import React, { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { EXECUTION_STATUSES, type ExecutionStatus } from './ShipmentStatusBadge';

interface ShipmentStatusFilterProps {
  selected: string[];
  onChange: (selected: string[]) => void;
}

const ShipmentStatusFilter: React.FC<ShipmentStatusFilterProps> = ({
  selected,
  onChange,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const toggle = (status: ExecutionStatus) => {
    if (selected.includes(status)) {
      onChange(selected.filter((s) => s !== status));
    } else {
      onChange([...selected, status]);
    }
  };

  const label =
    selected.length === 0
      ? t('shipment_filter_all_statuses')
      : selected.length === 1
        ? t(`shipment_status_${selected[0]}`)
        : t('shipment_filter_n_statuses', { count: selected.length });

  return (
    <div className="shipment-status-filter" ref={ref}>
      <button
        className="btn btn-secondary shipment-status-filter__trigger"
        onClick={() => setOpen((o) => !o)}
        type="button"
      >
        {label}
        <span className="shipment-status-filter__arrow">{open ? '▲' : '▼'}</span>
      </button>
      {open && (
        <div className="shipment-status-filter__dropdown">
          {EXECUTION_STATUSES.map((status) => (
            <label key={status} className="shipment-status-filter__option">
              <input
                type="checkbox"
                checked={selected.includes(status)}
                onChange={() => toggle(status)}
              />
              <span>{t(`shipment_status_${status}`)}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default ShipmentStatusFilter;
